import { createDocModalExecutor } from '@organisms/actions/createDocModalExecutor';
import { IEditDocumentTemplateExecutorProps } from './IEditDocumentTemplateExecutorProps';
import { EditDocumentTemplateExecutorModal } from './EditDocumentTemplateExecutorModal';

export const EditDocumentTemplateExecutor = createDocModalExecutor<IEditDocumentTemplateExecutorProps>({
    modal: EditDocumentTemplateExecutorModal,
    defaultModalSize: 'l',
    emptyElement: <div />,
    mapProps: ({ objId, action, okButtonText, cancelButtonText, modalSize, completeHandler }) => ({
        docId: objId ?? '',
        actionKey: action.key ?? '',
        title: action.options?.title ?? '',
        message: action.options?.message ?? '',
        okButtonText,
        cancelButtonText,
        modalSize,
        completeHandler,
    }),
});
